/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { BankAccount } from '../../../apollo/fragments/BankAccount.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBankAccountInfo_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly legalBusinessName: string | null };

export type GetBankAccountInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_selectedBankInfo_BankInfo = { readonly __typename: 'BankInfo', readonly id: string | null, readonly accountHolderName: string | null, readonly accountNumberLength: number | null, readonly accountNumberLastFour: string | null, readonly bankName: string | null, readonly routingNumber: string | null, readonly source: _Types.CreditApplicationBankSource | null, readonly externalConnectionGuid: string | null, readonly logoUrl: string | null };

export type GetBankAccountInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_bankInfo_BankInfo = { readonly __typename: 'BankInfo', readonly id: string | null, readonly accountHolderName: string | null, readonly accountNumberLength: number | null, readonly accountNumberLastFour: string | null, readonly bankName: string | null, readonly routingNumber: string | null, readonly source: _Types.CreditApplicationBankSource | null, readonly externalConnectionGuid: string | null, readonly logoUrl: string | null };

export type GetBankAccountInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_externalBankOptions_BankInfo = { readonly __typename: 'BankInfo', readonly id: string | null, readonly accountHolderName: string | null, readonly accountNumberLength: number | null, readonly accountNumberLastFour: string | null, readonly bankName: string | null, readonly routingNumber: string | null, readonly source: _Types.CreditApplicationBankSource | null, readonly externalConnectionGuid: string | null, readonly logoUrl: string | null };

export type GetBankAccountInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo = { readonly __typename: 'CreditApplicationFinanceInfo', readonly selectedBankInfo: GetBankAccountInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_selectedBankInfo_BankInfo | null, readonly bankInfo: GetBankAccountInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_bankInfo_BankInfo | null, readonly externalBankOptions: ReadonlyArray<GetBankAccountInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo_externalBankOptions_BankInfo | null> | null };

export type GetBankAccountInfo_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly businessInfo: GetBankAccountInfo_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo | null, readonly financeInfo: GetBankAccountInfo_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo | null };

export type GetBankAccountInfo_Query = { readonly __typename: 'Query', readonly creditApplication: GetBankAccountInfo_creditApplication_CreditApplication | null };


export type GetBankAccountInfoVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetBankAccountInfo = GetBankAccountInfo_Query;


export const GetBankAccountInfoDocument = gql`
    query GetBankAccountInfo($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    fetchedAt
    businessInfo {
      legalBusinessName
    }
    financeInfo {
      selectedBankInfo {
        ...BankAccount
      }
      bankInfo {
        ...BankAccount
      }
      externalBankOptions {
        ...BankAccount
      }
    }
  }
}
    ${BankAccount}`;

/**
 * __useGetBankAccountInfo__
 *
 * To run a query within a React component, call `useGetBankAccountInfo` and pass it any options that fit your needs.
 * When your component renders, `useGetBankAccountInfo` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankAccountInfo({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetBankAccountInfo(baseOptions: Apollo.QueryHookOptions<GetBankAccountInfo, GetBankAccountInfoVariables> & ({ variables: GetBankAccountInfoVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankAccountInfo, GetBankAccountInfoVariables>(GetBankAccountInfoDocument, options);
      }
export function useGetBankAccountInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankAccountInfo, GetBankAccountInfoVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankAccountInfo, GetBankAccountInfoVariables>(GetBankAccountInfoDocument, options);
        }
export function useGetBankAccountInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBankAccountInfo, GetBankAccountInfoVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBankAccountInfo, GetBankAccountInfoVariables>(GetBankAccountInfoDocument, options);
        }
export type GetBankAccountInfoHookResult = ReturnType<typeof useGetBankAccountInfo>;
export type GetBankAccountInfoLazyQueryHookResult = ReturnType<typeof useGetBankAccountInfoLazyQuery>;
export type GetBankAccountInfoSuspenseQueryHookResult = ReturnType<typeof useGetBankAccountInfoSuspenseQuery>;
export type GetBankAccountInfoQueryResult = Apollo.QueryResult<GetBankAccountInfo, GetBankAccountInfoVariables>;